export const SubscriptionStatus = {
  SUBSCRIBED: "SUBSCRIBED",
  TRIAL: "TRIAL",
  NOT_SUBSCRIBED: "NOT_SUBSCRIBED",
  BLOCKED: "BLOCKED"
};
